<!-- <div class="min-h-screen bg-slate-50 p-4 font-sans antialiased">
      <div class="max-w-[1600px] mx-auto flex gap-4">

            <div [ngClass]="isFormOpen ? 'w-2/3' : 'w-full'" class="transition-all duration-300 space-y-3">

                  <div
                        class="bg-white rounded-md shadow-sm border border-slate-200 p-4 flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta UI
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase font-medium">Manage system schema
                                    configurations</p>
                        </div>

                        <div class="flex items-center gap-3">
                              <div class="relative">
                                    <span
                                          class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-slate-400">
                                          <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                                    </span>
                                    <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()"
                                          placeholder="Search entities..."
                                          class="w-56 pl-8 pr-2 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none transition-all shadow-sm" />
                              </div>

                              <button (click)="openNewForm()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-xs font-bold transition-all shadow-sm flex items-center gap-1.5">
                                    <span class="text-sm">+</span> NEW ENTITY
                              </button>
                        </div>
                  </div>


                  <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden relative">
                        <div *ngIf="loading" class="absolute inset-0 bg-white/60 z-10 flex items-center justify-center">
                              <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                        </div>

                        <div class="overflow-x-auto">
                              <table class="w-full text-left border-collapse">
                                    <thead>
                                          <tr
                                                class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider font-bold">
                                                <th class="px-4 py-3">Entity Name</th>
                                                <th class="px-4 py-3">UI Schema Preview</th>
                                                <th class="px-4 py-3 text-right">Actions</th>
                                          </tr>
                                    </thead>
                                    <tbody class="divide-y divide-slate-100 text-xs">
                                          <tr *ngFor="let m of list"
                                                class="hover:bg-slate-50/80 transition-colors group">
                                                <td class="px-4 py-2.5 font-bold text-slate-700">{{ m.entityName }}</td>
                                                <td class="px-4 py-2.5">
                                                      <div
                                                            class="max-w-xs truncate font-mono text-blue-600 bg-blue-50/50 px-2 py-1 rounded border border-blue-100 text-[10px]">
                                                            {{ m.uiSchema }}
                                                      </div>
                                                </td>
                                                <td class="px-4 py-2.5 text-right">
                                                      <div class="flex items-center justify-end gap-3">
                                                            <button (click)="editItem(m)"
                                                                  class="text-slate-400 hover:text-blue-600 transition-colors">
                                                                  <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                        viewBox="0 0 24 24">
                                                                        <path stroke-linecap="round"
                                                                              stroke-linejoin="round" stroke-width="2"
                                                                              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                                                        </path>
                                                                  </svg>
                                                            </button>
                                                            <button (click)="deleteItem(m.id)"
                                                                  class="text-slate-400 hover:text-red-600 transition-colors">
                                                                  <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                        viewBox="0 0 24 24">
                                                                        <path stroke-linecap="round"
                                                                              stroke-linejoin="round" stroke-width="2"
                                                                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                                        </path>
                                                                  </svg>
                                                            </button>
                                                      </div>
                                                </td>
                                          </tr>
                                    </tbody>
                              </table>
                        </div>

                        <div
                              class="bg-white border-t border-slate-200 px-4 py-3 flex items-center justify-between text-[11px] font-bold">
                              <div class="flex items-center gap-3 text-slate-600">
                                    <span class="uppercase tracking-tighter">Show</span>
                                    <select [(ngModel)]="pageSize" (change)="onPageSizeChange()"
                                          class="border-2 border-slate-100 rounded-lg px-2 py-1 bg-slate-50 text-slate-800 outline-none focus:border-blue-500">
                                          <option [value]="5">5</option>
                                          <option [value]="10">10</option>
                                          <option [value]="25">25</option>
                                    </select>
                                    <span class="uppercase tracking-tighter">per page</span>
                              </div>

                              <div class="flex items-center gap-4 text-slate-600">
                                    <span>
                                          {{ (pageIndex * pageSize) + 1 }} - {{ ((pageIndex + 1) * pageSize >
                                          totalRecords) ? totalRecords
                                          : (pageIndex + 1) * pageSize }}
                                          OF <span class="text-slate-900">{{ totalRecords }}</span>
                                    </span>
                                    <div class="flex items-center gap-1">
                                          <button (click)="prevPage()" [disabled]="pageIndex === 0"
                                                class="p-1 disabled:opacity-30">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2" d="M15 19l-7-7 7-7"></path>
                                                </svg>
                                          </button>
                                          <div
                                                class="w-7 h-7 flex items-center justify-center bg-blue-50 text-blue-700 rounded border border-blue-100">
                                                {{ pageIndex + 1 }}</div>
                                          <button (click)="nextPage()"
                                                [disabled]="(pageIndex + 1) * pageSize >= totalRecords"
                                                class="p-1 disabled:opacity-30">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                      viewBox="0 0 24 24">
                                                      <path stroke-linecap="round" stroke-linejoin="round"
                                                            stroke-width="2" d="M9 5l7 7-7 7"></path>
                                                </svg>
                                          </button>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
      </div>

      <div *ngIf="isFormOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 md:p-10">
            <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" (click)="closeForm()">
            </div>

            <div
                  class="relative bg-white w-full max-w-5xl h-full max-h-[90vh] rounded-lg shadow-2xl flex flex-col overflow-hidden animate-in zoom-in-95 duration-200">

                  <div class="px-6 py-4 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
                        <div class="flex items-center gap-3">
                              <div class="p-2 bg-blue-600 rounded-lg">
                                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                                          </path>
                                    </svg>
                              </div>
                              <div>
                                    <h3 class="text-base font-bold text-slate-800 uppercase tracking-tight">
                                          {{ formData.id ? 'Edit Entity Configuration' : 'Create New Schema' }}
                                    </h3>
                                    <p class="text-[10px] text-slate-500 uppercase font-semibold">Workspace /
                                          Schema Designer
                                    </p>
                              </div>
                        </div>
                        <button (click)="closeForm()"
                              class="h-8 w-8 flex items-center justify-center rounded-full hover:bg-slate-200 text-slate-400 hover:text-slate-600 transition-all text-2xl">&times;</button>
                  </div>

                  <div class="flex-1 overflow-hidden flex flex-col p-6 space-y-6">

                        
                        <div class="group">
                              <label class="block text-[11px] font-bold text-slate-500 uppercase mb-2 tracking-wider">
                                    Select Target Entity
                              </label>
                              <select [(ngModel)]="formData.entityId"
                                    class="w-full px-4 py-2.5 border border-slate-200 rounded-md text-sm font-medium focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all bg-slate-50/50">
                                    <option value="" disabled>-- Choose an Entity --</option>
                                    <option *ngFor="let ent of entities" [value]="ent.id">
                                          {{ ent.name }} ({{ ent.code }})
                                    </option>
                              </select>
                        </div>

                        <div class="flex-1 flex flex-col min-h-0">
                              <div class="flex items-center justify-between mb-2">
                                    <label class="block text-[11px] font-bold text-slate-500 uppercase tracking-wider">UI
                                          Schema Definition (JSON)</label>

                              </div>
                              <div
                                    class="flex-1 relative rounded-md overflow-hidden border border-slate-800 bg-slate-900 group">
                                    <textarea [(ngModel)]="formData.uiSchema" spellcheck="false"
                                          placeholder='{ "type": "layout", "elements": [] }'
                                          class="absolute inset-0 w-full h-full p-4 font-mono text-xs text-emerald-400 bg-transparent outline-none resize-none leading-relaxed"></textarea>
                              </div>
                        </div>
                  </div>

                  <div class="px-6 py-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
                        <p class="text-[10px] text-slate-400 italic">Validation: Ensure JSON syntax is correct
                              before saving.
                        </p>
                        <div class="flex gap-3">
                              <button (click)="closeForm()"
                                    class="px-6 py-2 border border-slate-300 rounded-md text-slate-600 hover:bg-white transition-all font-bold text-xs uppercase tracking-widest">
                                    Discard
                              </button>
                        <button (click)="saveData()" [disabled]="loading"
                              class="px-8 py-2 bg-blue-600 text-white rounded-md font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-500/20 uppercase tracking-widest text-xs active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed">
                        
                              <span *ngIf="!loading">
                                    {{ formData.id ? 'Push Changes' : 'Initialize Schema' }}
                              </span>
                              <span *ngIf="loading">Processing...</span>
                        
                        </button>
                        </div>
                  </div>
            </div>

      </div> -->

<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased">
      <div class="max-w-[1600px] mx-auto">

            <div class="w-full mb-3">
                  <div class="bg-white rounded border border-slate-200 p-4 flex items-center justify-between shadow-sm">
                        <div>
                              <h2 class="text-xs font-black text-slate-800 uppercase tracking-tighter">Meta UI Designer
                              </h2>
                              <p class="text-[9px] text-slate-400 uppercase font-bold tracking-tight">Manage Layout
                                    Schemas</p>
                        </div>

                        <div class="flex items-center gap-3">
                              <div class="relative">
                                    <span
                                          class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-slate-400">
                                          <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                                    </span>
                                    <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()"
                                          placeholder="SEARCH SCHEMAS..."
                                          class="w-64 pl-8 pr-2 py-1.5 border border-slate-200 rounded text-[10px] font-bold uppercase focus:ring-1 focus:ring-blue-500 outline-none transition-all shadow-sm" />
                              </div>

                              <button (click)="openNewForm()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-[10px] font-black uppercase transition-all shadow-sm flex items-center gap-2">
                                    <span class="text-xs">+</span> NEW SCHEMA
                              </button>
                        </div>
                  </div>
            </div>

            <div class="bg-white rounded border border-slate-200 overflow-hidden relative shadow-sm w-full">
                  <div *ngIf="loading" class="absolute inset-0 bg-white/60 z-10 flex items-center justify-center">
                        <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
                  </div>

                  <table class="w-full text-left border-collapse">
                        <thead>
                              <tr
                                    class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[9px] uppercase tracking-widest font-black">
                                    <th class="px-4 py-3">Entity Reference</th>
                                    <th class="px-4 py-3">UI Schema Preview</th>
                                    <th class="px-4 py-3 text-right">Actions</th>
                              </tr>
                        </thead>
                        <tbody class="divide-y divide-slate-100">
                              <tr *ngFor="let m of list" class="hover:bg-slate-50/50 transition-colors group">
                                    <td class="px-4 py-3 font-bold text-slate-700 text-[10px] uppercase">{{ m.entityName
                                          }}</td>
                                    <td class="px-4 py-3">
                                          <div
                                                class="max-w-md truncate font-mono text-blue-600 bg-blue-50/40 px-2 py-1 rounded border border-blue-100 text-[9px]">
                                                {{ m.uiSchema }}
                                          </div>
                                    </td>
                                    <td class="px-4 py-3 text-right">
                                          <div class="flex items-center justify-end gap-3">
                                                <button (click)="editItem(m)"
                                                      class="text-slate-400 hover:text-blue-600 transition-colors">
                                                      <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  stroke-width="2"
                                                                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z">
                                                            </path>
                                                      </svg>
                                                </button>
                                                <button (click)="deleteItem(m.id)"
                                                      class="text-slate-400 hover:text-red-600 transition-colors">
                                                      <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  stroke-width="2"
                                                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                                                            </path>
                                                      </svg>
                                                </button>
                                          </div>
                                    </td>
                              </tr>
                        </tbody>
                  </table>

                  <div
                        class="bg-white border-t border-slate-200 px-4 py-3 flex items-center justify-between text-[11px] font-bold">
                        <div class="flex items-center gap-3 text-slate-600">
                              <span class="uppercase tracking-tighter">Show</span>
                              <select [(ngModel)]="pageSize" (change)="onPageSizeChange()"
                                    class="border-2 border-slate-100 rounded px-2 py-1 bg-slate-50 text-slate-800 outline-none focus:border-blue-500">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                              </select>
                              <span class="uppercase tracking-tighter">per page</span>
                        </div>

                        <div class="flex items-center gap-4 text-slate-600">
                              <span class="uppercase tracking-tighter">
                                    {{ (pageIndex * pageSize) + 1 }} - {{ ((pageIndex + 1) * pageSize > totalRecords) ?
                                    totalRecords : (pageIndex + 1) * pageSize }}
                                    OF <span class="text-slate-900">{{ totalRecords }}</span>
                              </span>

                              <div class="flex items-center gap-1">
                                    <button (click)="prevPage()" [disabled]="pageIndex === 0"
                                          class="p-1 disabled:opacity-30 hover:bg-slate-100 rounded transition-colors">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M15 19l-7-7 7-7"></path>
                                          </svg>
                                    </button>

                                    <div
                                          class="w-7 h-7 flex items-center justify-center bg-blue-50 text-blue-700 rounded border border-blue-100 shadow-sm">
                                          {{ pageIndex + 1 }}
                                    </div>

                                    <button (click)="nextPage()" [disabled]="(pageIndex + 1) * pageSize >= totalRecords"
                                          class="p-1 disabled:opacity-30 hover:bg-slate-100 rounded transition-colors">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M9 5l7 7-7 7"></path>
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>

            <div *ngIf="isFormOpen" class="fixed inset-0 z-50 flex items-center justify-center p-6">
                  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity"
                        (click)="closeForm()"></div>

                  <div
                        class="relative bg-white w-full max-w-4xl h-[85vh] rounded-lg shadow-2xl flex flex-col overflow-hidden border border-slate-200">

                        <div class="px-6 py-4 border-b border-slate-200 bg-slate-50 flex items-center justify-between">
                              <div class="flex items-center gap-3">
                                    <div class="p-2 bg-blue-600 rounded shadow-lg shadow-blue-200">
                                          <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z">
                                                </path>
                                          </svg>
                                    </div>
                                    <div>
                                          <h3 class="text-xs font-black text-slate-800 uppercase tracking-tighter">{{
                                                selectedId ? 'Update Schema' : 'Initialize New UI' }}</h3>
                                          <p class="text-[9px] text-slate-400 uppercase font-bold tracking-widest">
                                                Configuration Designer</p>
                                    </div>
                              </div>
                              <button (click)="closeForm()"
                                    class="text-slate-400 hover:text-slate-600 text-2xl transition-colors">&times;</button>
                        </div>

                        <div class="flex-1 overflow-y-auto p-6 space-y-6">
                              <div>
                                    <label
                                          class="block text-[10px] font-black text-slate-500 uppercase mb-2 tracking-widest">Select
                                          Target Entity</label>
                                    <select [(ngModel)]="formData.entityId"
                                          class="w-full px-4 py-2.5 border border-slate-200 rounded text-[11px] font-bold uppercase bg-slate-50 focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 outline-none transition-all">
                                          <option value="" disabled>-- CHOOSE ENTITY --</option>
                                          <option *ngFor="let ent of entities" [value]="ent.id">{{ ent.name }} ({{
                                                ent.code }})</option>
                                    </select>
                              </div>



                              <div class="flex flex-col h-[400px]">
                                    <label
                                          class="block text-[10px] font-black text-slate-500 uppercase mb-2 tracking-widest">UI
                                          Schema Definition (JSON)</label>
                                    <textarea [(ngModel)]="formData.uiSchema" spellcheck="false"
                                          class="flex-1 w-full p-4 font-mono text-[10px] text-emerald-500 bg-slate-900 border border-slate-800 rounded outline-none leading-relaxed resize-none shadow-inner"
                                          placeholder='{ "type": "layout", "rows": [] }'></textarea>
                              </div>
                        </div>

                        <div class="px-6 py-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
                              <p class="text-[9px] text-slate-400 font-bold uppercase italic">Ensure JSON format is
                                    valid before saving</p>
                              <div class="flex gap-3">
                                    <button (click)="closeForm()"
                                          class="px-5 py-2 border border-slate-300 rounded text-slate-600 hover:bg-white transition-all font-black text-[10px] uppercase tracking-widest">Discard</button>
                                    <button (click)="saveData()" [disabled]="loading"
                                          class="px-8 py-2 bg-blue-600 text-white rounded font-black hover:bg-blue-700 transition-all shadow-lg shadow-blue-500/20 uppercase tracking-widest text-[10px] disabled:opacity-50">
                                          {{ loading ? 'Saving...' : (selectedId ? 'Push Changes' : 'Save Schema') }}
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>

      </div>
</div>